
import mqtt from 'mqtt';

class MqttClient {
  constructor() {
    this.client = null;
    this.reconnectAttempts = 0; // 添加重连计数器
    this.maxReconnectAttempts = 10; // 设置最大重连次数
    this.subscriptionQueue = [];
    this.isReconnecting = false;
  }

  connect(uid, gid, server, accessToken, type) {
    const options = {
      username: type ? `${uid}_${gid}_2_${server}_CloudGame` : `${uid}_${gid}_2_${server}`,
      password: accessToken,
      cleanSession: false,
      keepalive: 60,
      clientId: type ? `${uid}_${gid}_2_${server}_CloudGame` : `${uid}_${gid}_2_${server}`,
      connectTimeout: 4000,
      reconnectPeriod: 5000, // 启用自动重连
    };

    this.client = mqtt.connect('wss://pkws.50pk.com:443/mqtt', options);

    this.client.on('connect', () => {
      console.log('链接成功')
      this.reconnectAttempts = 0; // 重置重连计数器
      this.processSubscriptionQueue();
    });

    this.client.on('reconnect', () => {
      this.reconnectAttempts++;

      // 超过最大重连次数时停止重连
      if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        console.warn(`已达到最大重连次数(${this.maxReconnectAttempts})，停止重连`);
        this.client.end(true); // 强制断开连接
      }
    });

    this.client.on('error', (err) => {
      console.error('MQTT错误:', err);
    });
  }

  subscribeTopics(topic, maxRetry = 3, retryDelay = 2000) {
    const subscribeWithRetry = (attempt = 1) => {
      this.client.subscribe(topic, { qos: 1 }, (err) => {
        if (err) {
          console.error(`订阅失败 [${attempt}/${maxRetry}]`, topic, err);
          
          if (attempt < maxRetry) {
            setTimeout(() => subscribeWithRetry(attempt + 1), retryDelay);
          } else {
            this.queueSubscription(topic);
          }
        } else {
          console.log("订阅成功", topic);
        }
      });
    };

    if (this.checkConnection()) {
      subscribeWithRetry();
    } else {
      this.queueSubscription(topic);
    }
  }

  queueSubscription(topic) {
    if (!this.subscriptionQueue.includes(topic)) {
      this.subscriptionQueue.push(topic);
      console.log(`主题 ${topic} 已加入订阅队列`);
    }
  }

  processSubscriptionQueue() {
    if (this.subscriptionQueue.length > 0 && this.checkConnection()) {
      console.log("处理待订阅主题队列...");
      const topics = [...this.subscriptionQueue];
      this.subscriptionQueue = [];
      
      topics.forEach(topic => {
        this.subscribeTopics(topic);
      });
    }
  }

  publish(topic, message) {
    if (!this.client.connected) {
      console.log('客户端未连接');
      return;
    }
    this.client.publish(topic, message, { qos: 1 }, (err) => {
      if (!err) {
        console.log('主题为' + topic + "发布成功");
      }
    });
  }

  unsubscribe(topic) {
    console.log(topic);
    this.client.unsubscribe(topic, error => {
      if (error) {
        console.log('主题为' + topic + '取消订阅成功', error);
      }
    });
  }

  getMessage(callback) {
    this.client.on("message", (topic, message) => {
      if (message) {
        // console.log('收到来自', topic, '的信息', message.toString());
        callback(topic, message.toString());
      }
    });
  }

  unconnect() {
    this.client.end();
    this.client = null;
    console.log('服务器已断开连接！');
  }

  checkConnection() {
    return (
      this.client &&
      this.client.connected
    );
  }
}

export default MqttClient;
